import { unpack } from '@/legacy/lib//util';
import Model from '@/legacy/lib//Model';

export default class Key extends Model
{
  constructor (props)
  {
    super ()

    Object.assign (
      this,
      unpack (props || {}, [
        'map',
        'ladder',
        'season',
        'round',
        'mode'
      ])
    );
  }
}